import React from "react";

import Stack from "@busbud/design-system-components/dist/Stack";
import type { Choices } from "@busbud/int-schemas/lib";
import type * as UDM from "@busbud/int-schemas/udm";

import { createArrayOfLength } from "@app/utils/array";

import { useStyles } from "./bus-horizontal.styles";
import { Cell } from "../../cell";
import { SeatGenderSelection } from "../../seat-gender-selection";

interface Props {
  active_seat?: UDM.SeatCell;
  columns_count: number;
  row: number;
  floor?: UDM.Floor;
  rows_count: number;
  active_seat_id: string | null;
  already_assigned_seat_ids: (string | null)[];
  onSeatChange: (seat: UDM.SeatCell) => void;
  onGenderChange?: (gender: Choices.Gender) => void;
  seatClassResolver?: (seat_id: string) => string | null;
}
export const BusColumn: React.FC<Props> = props => {
  const { classes } = useStyles();
  const {
    active_seat,
    rows_count,
    columns_count,
    active_seat_id,
    already_assigned_seat_ids,
    floor,
    row,
    onSeatChange,
    onGenderChange,
    seatClassResolver
  } = props;

  return (
    <Stack direction="column-reverse" key={row} spacing={1}>
      {createArrayOfLength(columns_count).map((_, column) => {
        // helpers to display the tooltip always within the bus layout
        // and it does not go past outside
        const first_column = column < Math.ceil(columns_count / 2);
        const last_row = row > rows_count - 4;

        const cell = floor?.cells?.[row]?.[column];
        const is_selected =
          cell && cell.type === "seat" && cell.id === active_seat_id;

        return (
          <div className={classes.seatContainer} key={`${row}-${column}`}>
            <Cell
              cell={cell}
              orientation="left"
              active_seat_id={active_seat_id}
              already_assigned_seat_ids={already_assigned_seat_ids}
              onSeatSelected={onSeatChange}
              seatClassResolver={seatClassResolver}
            />
            {!!is_selected && !!onGenderChange && (
              <SeatGenderSelection
                first_column={first_column}
                last_row={last_row}
                horizontal
                allowed_gender={active_seat?.gender}
                onGenderSelect={onGenderChange}
              />
            )}
          </div>
        );
      })}
    </Stack>
  );
};
